import { EnvironmentInterface } from '../interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  apiDomain: 'eurodev.bi4dev.com',
  universityApiDomain: 'app.dev.educa.university',
  apiProtocol: 'https',
  apiPath: 'api',
  lhcURL: 'lhcdev.bi4dev.com',
  captchaKey: '6Les7D0dAAAAAIffPAHBCNTHFnKnG6pcm1YqkuNR',
  verticalURL: 'eurodev.bi4dev.com',
  universityURL: 'dev.app.educa.university',
  regionsAvailables: ['EU']
};
